import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface FeatureListProps {
  items: Array<string | { text: string; onClick?: () => void; contentId?: string; action?: string }>;
}

const FeatureList: React.FC<FeatureListProps> = ({ items }) => {
  return (
    <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {items.map((item, index) => {
        const isString = typeof item === 'string';
        const text = isString ? item : item.text;
        const onClick = isString ? undefined : item.onClick;
        const contentId = isString ? undefined : item.contentId;
        const action = isString ? undefined : item.action;

        return (
          <Box
            key={index}
            component="li"
            onClick={onClick}
            data-content-id={contentId}
            data-action={action}
            sx={{
              background: 'var(--white)',
              border: '1px solid #e0e7ff',
              borderRadius: '6px',
              padding: '12px 16px',
              margin: '8px 0',
              display: 'flex',
              alignItems: 'center',
              cursor: (onClick || contentId || action) ? 'pointer' : 'default',
              transition: 'all 0.3s ease',
              '&:hover': (onClick || contentId || action) ? {
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                transform: 'translateX(4px)',
              } : {},
            }}
          >
            <CheckIcon
              sx={{
                color: 'var(--primary-blue)',
                fontSize: '18px',
                marginRight: '12px',
                fontWeight: 'bold',
              }}
            />
            <Typography
              sx={{
                fontFamily: 'var(--font-body)',
                fontSize: '14px',
                color: 'var(--dark-gray)',
              }}
            >
              {text}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default FeatureList;

